// eslint-disable-next-line import/no-anonymous-default-export
export default {
  styleOverrides: {
    root: {
      marginTop: 0,
      marginBottom: 0,
    },
  },
};
